<div class="row">
    <app-cybersocxmenu></app-cybersocxmenu>
</div>
<p>cybersocxdrcomopgen works!</p>
